import * as React from 'react';
import { Prompt } from 'react-router';
import { Link } from 'react-router-dom';
import { Card } from 'material-ui/Card';
import { get } from 'lodash';
import ReactDiffViewer from 'react-diff-viewer';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, withProps } from 'recompose';
import { reduxForm } from 'redux-form';

import { Input, InputField, DateField, Date } from '@components/form';
import * as T from '@modules/history/_historyTypes';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { required } from '@utils/validators';
import { getHistoryEvent } from '@modules/history/_historyActions';
import { historyPath } from './HistoryGrid';

const enhance = compose<T.HistoryFormProps, T.HistoryFormProps>(
  withProps(() => {
    const params = new URLSearchParams(location.search);
    const isFromEvent = !!params.get('isFromEvent');

    return {
      isFromEvent: isFromEvent,
      eventPath: isFromEvent ? `/events?item=${params.get('isFromEvent')}&activeTab=histories` : '/events',
      eventId: params.get('isFromEvent') || ''
    };
  }),
  EntityDetailEnhancer<T.HistoryEnhancerProps<T.HistoryEvent>, T.HistoryEvent>({
    getEntity: getHistoryEvent,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Historie', to: historyPath },
    { label: get(entity, 'entity', 'Nová událost') }
  ]),
  withProps<{}, T.HistoryForm>(({ entity }) => ({
    initialValues: get(entity, 'id') ? entity : {}
  })),
  reduxForm({
    form: 'historyForm'
  })
);

const View: React.SFC<T.HistoryFormProps> = props => {
  const backPath = props.isFromEvent ? props.eventPath : historyPath;

  const getValue = (attr: string) => JSON.stringify(JSON.parse(get(props.entity, attr, '{}')), undefined, 4);

  return (
    <div>
      <Prompt
        when={props.dirty && !props.submitSucceeded && !props.submitting}
        message="Vaše změny nebyly uloženy, přesto odejít?"
      />
      <form className="layout" onSubmit={props.handleSubmit}>
        <Card>
          <Grid fluid={true}>
            <Row>
              <Col className="grid-system-margin" />
            </Row>
            <Row>
              <Col md={12}>
                <Row>
                  <Col md={12}>
                    <h4>Základní údaje</h4>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <InputField
                      component={Input}
                      name="entity"
                      label="Událost *"
                      validate={[required]}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <InputField component={Input} name="user" label="Uživatel" disabled={true} />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <DateField component={Date} name="created" label="Vytvořeno" dateOnly={false} disabled={true} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className="history-diff">
                      <ReactDiffViewer
                        oldValue={getValue('before')}
                        newValue={getValue('after')}
                        splitView={true}
                        leftTitle="Před"
                        rightTitle="Po"
                        styles={{
                          titleBlock: { fontSize: 16, fontWeight: 'bold' }
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Grid>
          <Button label="Zpět" style={{ margin: '16px 0 16px 16px' }} containerElement={<Link to={backPath} />} />
        </Card>
      </form>
    </div>
  );
};

export const HistoryForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/history/HistoryForm.tsx